// Los diccionarios viven en ./translations/{pt,es,en,it}.js y se cargan
// por idioma bajo demanda (code splitting): PT va en el bundle principal
// porque es el idioma por defecto de la marca.
export const LANGS = [
  { code: "pt", label: "PT" },
  { code: "es", label: "ES" },
  { code: "en", label: "EN" },
  { code: "it", label: "IT" },
];
